<template>
  <div class="contentArea">
    <AgGrid />
    <span class="flex justify-end"
      ><p>
        <b>หมายเหตุ***</b>
        หากต้องการ<b>ลบผู้สอน</b>&nbsp;กรุณาตรวจสอบให้แน่ใจว่า<b
          >ผู้สอนนั้นไม่มีอยู่ในหลักสูตร</b
        >
      </p></span
    >
  </div>
</template>

<script>
import AgGrid from "../elements/ag-grid-table/AgGridTable.vue";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      tabActive: "general/tabActive",
      page: "general/page"
    })
  },
  components: {
    AgGrid
  },

  async mounted() {
    await this.$store.dispatch("general/get_LecturerTable");
    this.$store.dispatch("general/push_pointer", "lecturer");
  }
};
</script>

<style lang="scss" scoped></style>
